import * as turf from '@turf/turf';
import { LocationPoint } from '../../../../../types/locations';
import { PointGeometry } from './constants';

/** Calculates the centroid (center of gravity) for a list of points. */
export const getCentroidFromLocationPoints = (
  points: Pick<LocationPoint, 'longitude' | 'latitude'>[] | LocationPoint[]
): PointGeometry | null => {
  if (points.length === 0) return null;

  const feature = turf.points(points.map((p) => [p.longitude, p.latitude]));
  const centroid = turf.centroid(feature);

  const [longitude, latitude] = centroid.geometry.coordinates;
  return {
    longitude,
    latitude,
  };
};
